// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-eform {
  cursor: unset !important;
  outline: none !important;
}

.mat-button {
  position: relative;
  float: right;
}

.field-three, .field-two, .field-one {
  margin: 0 !important;
}

.div-btn {
  position: absolute;
  right: 0;
}

.section-body-field-one, .section-body-field-two, .section-body-field-three {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.section-body-field-one {
  margin: 0 2px -5px 10px !important;
}

.section-body-field-two {
  margin: 0 -8px -5px 10px !important;
}

.section-body-field-three {
  margin: 0 -50px -5px 10px !important;
}

.field-three {
  flex: 0 0 34%;
  margin: 5px;
  background-color: transparent;
  position: relative;
  max-width: 363px;
}

.form-builder {
  padding-bottom: 12px;
  margin-left: -5px;
}

/* For device */
@media (min-width: 0px) and (max-width: 400px) {
  .section-eform {
    min-width: unset;
  }
  .div-btn {
    bottom: 0;
  }
}
@media (min-width: 400px) and (max-width: 1400px) {
  .section-eform {
    min-width: unset;
  }
  .div-btn {
    bottom: 0;
  }
}
@media (min-width: 0px) and (max-width: 330px) {
  .section-eform {
    max-width: 200px;
  }
  .form-builder {
    width: 200px;
  }
}
@media (min-width: 330px) and (max-width: 375px) {
  .section-eform {
    min-width: 230px;
  }
  .form-builder {
    width: 230px;
  }
}
@media (min-width: 375px) and (max-width: 500px) {
  .section-eform {
    min-width: 245px;
  }
  .form-builder {
    width: 245px;
  }
}
@media (min-width: 500px) and (max-width: 667px) {
  .section-eform {
    min-width: 380px;
  }
  .form-builder {
    width: 380px;
  }
}
@media (min-width: 667px) and (max-width: 730px) {
  .section-eform {
    min-width: 460px;
  }
  .form-builder {
    width: 460px;
  }
}
@media (min-width: 730px) and (max-width: 812px) {
  .section-eform {
    min-width: 520px;
  }
  .form-builder {
    width: 520px;
  }
}
@media (min-width: 812px) and (max-width: 1024px) {
  .section-eform {
    min-width: 560px;
  }
  .form-builder {
    width: 560px;
  }
}
@media (min-width: 1024px) and (max-width: 1128px) {
  .section-eform {
    min-width: 730px;
  }
  .form-builder {
    width: 730px;
  }
}
@media (min-width: 1128px) and (max-width: 1200px) {
  .section-eform {
    min-width: 820px;
  }
  .form-builder {
    width: 820px;
  }
}
@media (min-width: 1200px) and (max-width: 1300px) {
  .section-eform {
    min-width: 900px;
  }
  .form-builder {
    width: 900px;
  }
}
@media (min-width: 1300px) and (max-width: 1360px) {
  .section-eform {
    min-width: 950px;
  }
  .form-builder {
    width: 950px;
  }
}
@media (min-width: 1366px) and (max-width: 1400px) {
  .section-eform {
    min-width: 1000px;
  }
  .form-builder {
    width: 1000px;
  }
}
@media (min-width: 0px) and (max-width: 740px) {
  .field-three {
    flex: 0 0 99%;
  }
  .field-two {
    flex: 0 0 99%;
  }
}
@media (min-width: 740px) and (max-width: 1300px) {
  .field-three {
    flex: 0 0 50%;
  }
}
.section-description {
  margin-bottom: 18px;
}

.div-form {
  max-width: 100%;
  min-width: unset;
}

.unset-overflow {
  overflow: unset;
}

.form-field-three {
  margin: 0 -25px -5px 10px !important;
}

@media (min-width: 1199px) and (max-width: 1300px) {
  .fix-width {
    max-width: 423px !important;
  }
}
@media (min-width: 1127px) and (max-width: 1199px) {
  .fix-width {
    max-width: 383px !important;
  }
}
@media (min-width: 1023px) and (max-width: 1127px) {
  .fix-width {
    max-width: 338px !important;
  }
}
@media (min-width: 811px) and (max-width: 1023px) {
  .fix-width {
    max-width: 253px !important;
  }
}
@media (min-width: 739px) and (max-width: 811px) {
  .fix-width {
    max-width: 233px !important;
  }
}
@media (max-width: 739px) {
  .fix-width {
    max-width: 90.7% !important;
  }
}
.pointer-event-none {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/dynamic-form-builder/dynamic-form-builder.component.scss"],"names":[],"mappings":"AAAA;EACG,wBAAA;EACA,wBAAA;AACH;;AAEA;EACG,kBAAA;EACA,YAAA;AACH;;AAEA;EACG,oBAAA;AACH;;AAEA;EACG,kBAAA;EACA,QAAA;AACH;;AAEA;EACG,aAAA;EACA,mBAAA;EACA,eAAA;AACH;;AAEA;EACG,kCAAA;AACH;;AAEA;EACG,mCAAA;AACH;;AAEA;EACG,oCAAA;AACH;;AAEA;EACG,aAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;AACH;;AAEA;EACG,oBAAA;EACA,iBAAA;AACH;;AAEA,eAAA;AACA;EACG;IACG,gBAAA;EACJ;EAEC;IACG,SAAA;EAAJ;AACF;AAGA;EACG;IACG,gBAAA;EADJ;EAIC;IACG,SAAA;EAFJ;AACF;AAKA;EACG;IACG,gBAAA;EAHJ;EAMC;IACG,YAAA;EAJJ;AACF;AAOA;EACG;IACG,gBAAA;EALJ;EAQC;IACG,YAAA;EANJ;AACF;AASA;EACG;IACG,gBAAA;EAPJ;EAUC;IACG,YAAA;EARJ;AACF;AAWA;EACG;IACG,gBAAA;EATJ;EAYC;IACG,YAAA;EAVJ;AACF;AAaA;EACG;IACG,gBAAA;EAXJ;EAcC;IACG,YAAA;EAZJ;AACF;AAeA;EACG;IACG,gBAAA;EAbJ;EAgBC;IACG,YAAA;EAdJ;AACF;AAiBA;EACG;IACG,gBAAA;EAfJ;EAkBC;IACG,YAAA;EAhBJ;AACF;AAmBA;EACG;IACG,gBAAA;EAjBJ;EAoBC;IACG,YAAA;EAlBJ;AACF;AAqBA;EACG;IACG,gBAAA;EAnBJ;EAsBC;IACG,YAAA;EApBJ;AACF;AAuBA;EACG;IACG,gBAAA;EArBJ;EAwBC;IACG,YAAA;EAtBJ;AACF;AAyBA;EACG;IACG,gBAAA;EAvBJ;EA0BC;IACG,YAAA;EAxBJ;AACF;AA2BA;EACG;IACG,iBAAA;EAzBJ;EA4BC;IACG,aAAA;EA1BJ;AACF;AA6BA;EACG;IACG,aAAA;EA3BJ;EA8BC;IACG,aAAA;EA5BJ;AACF;AA+BA;EACG;IACG,aAAA;EA7BJ;AACF;AAgCA;EACG,mBAAA;AA9BH;;AAiCA;EACG,eAAA;EACA,gBAAA;AA9BH;;AAiCA;EACG,eAAA;AA9BH;;AAiCA;EACG,oCAAA;AA9BH;;AAiCA;EACG;IACG,2BAAA;EA9BJ;AACF;AAiCA;EACG;IACG,2BAAA;EA/BJ;AACF;AAkCA;EACG;IACG,2BAAA;EAhCJ;AACF;AAmCA;EACG;IACG,2BAAA;EAjCJ;AACF;AAoCA;EACG;IACG,2BAAA;EAlCJ;AACF;AAqCA;EACG;IACG,2BAAA;EAnCJ;AACF;AAsCA;EACG,oBAAA;AApCH","sourcesContent":[".section-eform {\n   cursor: unset !important;\n   outline: none !important;\n}\n\n.mat-button {\n   position: relative;\n   float: right;\n}\n\n.field-three, .field-two, .field-one {\n   margin: 0 !important;\n}\n\n.div-btn {\n   position: absolute;\n   right: 0;\n}\n\n.section-body-field-one, .section-body-field-two,  .section-body-field-three{\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n}\n\n.section-body-field-one {\n   margin: 0 2px -5px 10px !important;\n}\n\n.section-body-field-two {\n   margin: 0 -8px -5px 10px !important;\n}\n\n.section-body-field-three {\n   margin: 0 -50px -5px 10px !important;\n}\n\n.field-three {\n   flex: 0 0 34%;\n   margin: 5px;\n   background-color: transparent;\n   position: relative;\n   max-width: 363px;\n}\n\n.form-builder {\n   padding-bottom: 12px;\n   margin-left: -5px;\n}\n\n/* For device */\n@media (min-width: 0px) and (max-width: 400px) {\n   .section-eform {\n      min-width: unset;\n   }\n\n   .div-btn {\n      bottom: 0;\n   }\n}\n\n@media (min-width: 400px) and (max-width: 1400px) {\n   .section-eform {\n      min-width: unset;\n   }\n\n   .div-btn {\n      bottom: 0;\n   }\n}\n\n@media (min-width: 0px) and (max-width: 330px) {\n   .section-eform {\n      max-width: 200px;\n   }\n\n   .form-builder {\n      width: 200px;\n   }\n}\n\n@media (min-width: 330px) and (max-width: 375px) {\n   .section-eform {\n      min-width: 230px;\n   }\n\n   .form-builder {\n      width: 230px;\n   }\n}\n\n@media (min-width: 375px) and (max-width: 500px) {\n   .section-eform {\n      min-width: 245px;\n   }\n\n   .form-builder {\n      width: 245px;\n   }\n}\n\n@media (min-width: 500px) and (max-width: 667px) {\n   .section-eform {\n      min-width: 380px;\n   }\n\n   .form-builder {\n      width: 380px;\n   }\n}\n\n@media (min-width: 667px) and (max-width: 730px) {\n   .section-eform {\n      min-width: 460px;\n   }\n\n   .form-builder {\n      width: 460px;\n   }\n}\n\n@media (min-width: 730px) and (max-width: 812px) {\n   .section-eform {\n      min-width: 520px;\n   }\n\n   .form-builder {\n      width: 520px;\n   }\n}\n\n@media (min-width: 812px) and (max-width: 1024px) {\n   .section-eform {\n      min-width: 560px;\n   }\n\n   .form-builder {\n      width: 560px;\n   }\n}\n\n@media (min-width: 1024px) and (max-width: 1128px) {\n   .section-eform {\n      min-width: 730px;\n   }\n\n   .form-builder {\n      width: 730px;\n   }\n}\n\n@media (min-width: 1128px) and (max-width: 1200px) {\n   .section-eform {\n      min-width: 820px;\n   }\n\n   .form-builder {\n      width: 820px;\n   }\n}\n\n@media (min-width: 1200px) and (max-width: 1300px) {\n   .section-eform {\n      min-width: 900px;\n   }\n\n   .form-builder {\n      width: 900px;\n   }\n}\n\n@media (min-width: 1300px) and (max-width: 1360px) {\n   .section-eform {\n      min-width: 950px;\n   }\n\n   .form-builder {\n      width: 950px;\n   }\n}\n\n@media (min-width: 1366px) and (max-width: 1400px) {\n   .section-eform {\n      min-width: 1000px;\n   }\n\n   .form-builder {\n      width: 1000px;\n   }\n}\n\n@media (min-width: 0px) and (max-width: 740px) {\n   .field-three {\n      flex: 0 0 99%;\n   }\n\n   .field-two {\n      flex: 0 0 99%;\n   }\n}\n\n@media (min-width: 740px) and (max-width: 1300px) {\n   .field-three {\n      flex: 0 0 50%;\n   }\n}\n\n.section-description {\n   margin-bottom: 18px;\n}\n\n.div-form {\n   max-width: 100%;\n   min-width: unset;\n}\n\n.unset-overflow {\n   overflow: unset;\n}\n\n.form-field-three {\n   margin: 0 -25px -5px 10px !important;\n}\n\n@media (min-width: 1199px) and (max-width: 1300px) {\n   .fix-width {\n      max-width: 423px !important;\n   }\n}\n\n@media (min-width: 1127px) and (max-width: 1199px) {\n   .fix-width {\n      max-width: 383px !important;\n   }\n}\n\n@media (min-width: 1023px) and (max-width: 1127px) {\n   .fix-width {\n      max-width: 338px !important;\n   }\n}\n\n@media (min-width: 811px) and (max-width: 1023px) {\n   .fix-width {\n      max-width: 253px !important;\n   }\n}\n\n@media (min-width: 739px) and (max-width: 811px) {\n   .fix-width {\n      max-width: 233px !important;\n   }\n}\n\n@media (max-width: 739px) {\n   .fix-width {\n      max-width: 90.7% !important;\n   }\n}\n\n.pointer-event-none {\n   pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
